import SuccessIcon from '../../assets/img/success-icon.png';

import LoginFooter from '../../Component/Footer';
const PaymentSuccess = () => {
    return (<>
        <div className="loginrgstr-page paymentsuccessPage">
            <div className="login_main">
                <section className='loginrgstrform-section'>
                <div className='loginrgstr-maincover'>
                <div className='container'>
                <div className='loginrgstr-main'>
                <form>
                    <div className='subscrbwatchads-area'>
                        <div className="subscrbwatchads-grid">
                            <div className="subscrbwatchads-gridcard subscr-panel">
                            <img src={SuccessIcon} alt="" />
                            <h3>You are Subscribed!</h3>
                            <p>Enjoy Unlimite access premium contents .</p>
                            <ul>
                                <li> <strong>Plan:</strong> Premium</li>
                                <li><strong>Valid Till:</strong> Aug 24, 2025</li>
                                <li><strong>Payment Mode:</strong> UPI</li>
                            </ul>
                            <button className="subscrbwatchads-btn watchnow-btn w-100">
                                Watch Now
                            </button>
                            <button className="browsemore-btn">
                                Browse More
                            </button>
                            </div>
                        </div>
                    </div>
                    </form>
                    </div>
                    </div>
                </div>
                </section>
                <LoginFooter />
            </div>
        </div>
    </>)
}


export default PaymentSuccess;